/* Luveon testimonial videos: media and the optional HLS reader load on activation only. */
(function () {
  'use strict';
  if (window.LuveonVideoTestimonials) {
    window.LuveonVideoTestimonials.init(document);
    return;
  }

  var hlsPromise;
  function loadHls(url) {
    if (hlsPromise) return hlsPromise;
    hlsPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var settled = false;
      var timeout = setTimeout(function () { fail(); }, 10000);
      function fail() {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        hlsPromise = null;
        script.remove();
        reject(new Error('HLS unavailable'));
      }
      script.src = url;
      script.async = true;
      script.onload = function () {
        if (settled) return;
        if (window.Hls && window.Hls.isSupported()) {
          settled = true;
          clearTimeout(timeout);
          resolve(window.Hls);
        } else fail();
      };
      script.onerror = fail;
      document.head.appendChild(script);
    });
    return hlsPromise;
  }

  function Controller(root) {
    var viewport = root.querySelector('[data-lma-vt-viewport]');
    if (!viewport) return;
    var originals = Array.prototype.slice.call(viewport.querySelectorAll('[data-lma-vt-card]'));
    if (!originals.length) return;
    var listeners = [], observers = [], destroyed = false, active = null, timer = null, frame = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var sectionVisible = false, autoAttempted = false, interacted = false, hover = false;
    var loop = root.dataset.loop === 'true' && originals.length > 1, loopWidth = 0, wrapping = false;
    var suppressClickUntil = 0, pointerStart = null;
    function on(element, type, callback, options) {
      element.addEventListener(type, callback, options);
      listeners.push(function () { element.removeEventListener(type, callback, options); });
    }
    if (loop) originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.dataset.lmaVtClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.querySelectorAll('button').forEach(function (button) { button.setAttribute('tabindex', '-1'); });
      viewport.appendChild(clone);
    });
    var states = Array.prototype.map.call(viewport.querySelectorAll('[data-lma-vt-card]'), function (card) {
      var video = card.querySelector('[data-lma-vt-video]');
      var sources = video ? Array.prototype.slice.call(video.querySelectorAll('source[data-src]')) : [];
      var hlsSource = sources.find(function (source) { return /mpegurl/i.test(source.type) || /\.m3u8(?:\?|$)/i.test(source.dataset.src); });
      var mp4Source = sources.find(function (source) { return /mp4/i.test(source.type); });
      return { card: card, video: video, status: card.querySelector('[data-lma-vt-status]'),
        play: card.querySelector('[data-lma-vt-play]'), sound: card.querySelector('[data-lma-vt-sound]'),
        hlsUrl: hlsSource && hlsSource.dataset.src, mp4Url: (mp4Source && mp4Source.dataset.src) || (video && video.dataset.src),
        ratio: 0, request: 0, pending: false, automatic: false, engine: null, mode: '', fallback: false,
        time: 0, unmuted: false, loadingTimer: null };
    });
    function ui(state, value, message) {
      state.card.dataset.lmaVtState = value;
      state.card.classList.toggle('is-playing', value === 'playing');
      state.card.classList.toggle('is-loading', value === 'loading');
      state.card.classList.toggle('is-error', value === 'error');
      state.card.classList.toggle('is-auto', state.automatic);
      state.card.classList.toggle('is-unmuted', state.video && !state.video.muted);
      state.card.setAttribute('aria-busy', value === 'loading' ? 'true' : 'false');
      if (state.status) state.status.textContent = message || '';
      if (state.play) state.play.setAttribute('aria-label', value === 'playing' ? 'Mettre la vidéo en pause' : value === 'loading' ? 'Annuler le chargement' : value === 'error' ? 'Réessayer la vidéo' : 'Lire la vidéo');
      if (state.sound) {
        state.sound.setAttribute('aria-label', state.video && !state.video.muted ? 'Couper le son' : 'Activer le son');
        state.sound.setAttribute('aria-pressed', state.video && !state.video.muted ? 'true' : 'false');
      }
    }
    function release(state) {
      if (state.engine) { state.engine.destroy(); state.engine = null; }
      if (!state.video) return;
      if (state.video.hasAttribute('src')) {
        state.video.removeAttribute('src');
        state.video.load(); // Abort an inactive download and free its decoder/buffer.
      }
      state.video.preload = 'none';
      delete state.video.dataset.lmaVtHydrated;
      state.mode = '';
    }
    function stop(state, value, message) {
      state.request += 1;
      state.pending = false;
      clearTimeout(state.loadingTimer);
      if (state.video) {
        if (Number.isFinite(state.video.currentTime)) state.time = state.video.currentTime;
        state.video.pause();
        state.video.muted = true;
      }
      state.automatic = false;
      if (active === state) active = null;
      release(state);
      ui(state, value || 'paused', message);
    }
    function valid(state, request) { return !destroyed && active === state && state.request === request && !document.hidden; }
    function loading(state) {
      state.pending = true;
      ui(state, 'loading', 'Chargement…');
      clearTimeout(state.loadingTimer);
      state.loadingTimer = setTimeout(function () {
        if (active === state && state.pending) ui(state, 'loading', 'Chargement… Touchez pour annuler.');
      }, 12000);
    }
    function failure(state, request, error) {
      if (!valid(state, request)) return;
      if (error && error.name === 'NotAllowedError') {
        if (!state.video.muted) { state.unmuted = false; state.video.muted = true; attempt(state, request); return; }
        stop(state, 'paused'); // A tap remains available when automatic playback is blocked.
        return;
      }
      if (error && error.name === 'AbortError' && !state.video.error) { stop(state, 'paused'); return; }
      if (state.mode !== 'mp4' && state.mp4Url && !state.fallback) {
        state.fallback = true;
        release(state);
        state.mode = 'mp4';
        state.video.preload = 'auto';
        state.video.src = state.mp4Url;
        state.video.dataset.lmaVtHydrated = 'true';
        loading(state);
        attempt(state, request);
        return;
      }
      stop(state, 'error', 'Vidéo indisponible. Touchez pour réessayer.');
    }
    function attempt(state, request) {
      if (!valid(state, request)) return;
      try {
        var promise = state.video.play();
        if (promise && promise.catch) promise.catch(function (error) { failure(state, request, error); });
      } catch (error) { failure(state, request, error); }
    }
    function nativeHls(video) {
      // Chromium can report "maybe" while failing these Shopify streams.
      return video.canPlayType('application/vnd.apple.mpegurl') &&
        (!window.MediaSource || 'ManagedMediaSource' in window || /Apple/i.test(navigator.vendor || ''));
    }
    function prepare(state, request) {
      var video = state.video;
      video.preload = 'auto';
      video.dataset.lmaVtHydrated = 'true';
      if (state.hlsUrl && nativeHls(video)) {
        state.mode = 'native-hls';
        video.src = state.hlsUrl;
        attempt(state, request);
      } else if (state.hlsUrl && (window.MediaSource || window.ManagedMediaSource)) {
        state.mode = 'hls';
        loadHls(root.dataset.hlsLibrary).then(function (Hls) {
          if (!valid(state, request)) return;
          var retry = { maxNumRetry: 1, retryDelayMs: 500, maxRetryDelayMs: 1000 };
          var hls = new Hls({ enableWorker: true, startLevel: 0, capLevelToPlayerSize: false,
            maxBufferLength: 8, maxMaxBufferLength: 16, backBufferLength: 4, maxBufferSize: 8000000,
            manifestLoadPolicy: { default: { maxTimeToFirstByteMs: 8000, maxLoadTimeMs: 12000, timeoutRetry: retry, errorRetry: retry } },
            playlistLoadPolicy: { default: { maxTimeToFirstByteMs: 8000, maxLoadTimeMs: 12000, timeoutRetry: retry, errorRetry: retry } }
          });
          state.engine = hls;
          hls.on(Hls.Events.MEDIA_ATTACHED, function () {
            if (valid(state, request) && state.engine === hls) { hls.loadSource(state.hlsUrl); attempt(state, request); }
          });
          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            if (!valid(state, request) || state.engine !== hls) return;
            var target = parseInt(root.dataset.maxHeight, 10) || 720, cap = 0;
            hls.levels.forEach(function (level, index) { if (level.height <= target) cap = index; });
            hls.autoLevelCapping = cap;
            attempt(state, request);
          });
          hls.on(Hls.Events.ERROR, function (event, data) {
            if (data.fatal && state.engine === hls) failure(state, request, new Error('HLS media error'));
          });
          hls.attachMedia(video);
        }).catch(function (error) { failure(state, request, error); });
      } else if (state.mp4Url) {
        state.mode = 'mp4';
        video.src = state.mp4Url;
        attempt(state, request);
      } else failure(state, request, new Error('No video source'));
    }
    function play(state, automatic, unmuted) {
      if (!state.video || document.hidden || destroyed) return;
      if (active) stop(active);
      active = state;
      var request = ++state.request;
      state.automatic = !!automatic;
      state.fallback = false;
      state.unmuted = !!unmuted && !automatic;
      state.video.muted = !state.unmuted;
      loading(state);
      prepare(state, request);
    }
    function toggle(state) {
      interacted = true;
      if (active === state && (state.pending || !state.video.paused)) stop(state);
      else play(state, false, false);
    }
    states.forEach(function (state) {
      if (!state.video) return;
      ui(state, 'idle');
      on(state.card, 'click', function (event) {
        if (event.target.closest('button') || Date.now() < suppressClickUntil) return;
        toggle(state);
      });
      if (state.play) on(state.play, 'click', function (event) { event.stopPropagation(); toggle(state); });
      if (state.sound) on(state.sound, 'click', function (event) {
        event.stopPropagation(); interacted = true;
        if (active !== state) { play(state, false, true); return; }
        state.video.muted = !state.video.muted;
        state.unmuted = !state.video.muted;
        ui(state, state.pending ? 'loading' : state.video.paused ? 'paused' : 'playing', state.pending ? 'Chargement…' : '');
        attempt(state, state.request); // Keep sound activation in this user gesture.
      });
      on(state.video, 'loadedmetadata', function () {
        if (active === state && state.time > 0 && Number.isFinite(state.video.duration)) {
          state.video.currentTime = Math.min(state.time, Math.max(0, state.video.duration - 0.1));
          state.time = 0;
        }
      });
      on(state.video, 'playing', function () {
        if (active !== state || document.hidden) { state.video.pause(); return; }
        state.pending = false; clearTimeout(state.loadingTimer); ui(state, 'playing');
      });
      on(state.video, 'waiting', function () { if (active === state) loading(state); });
      on(state.video, 'pause', function () {
        if (active === state && !state.pending && state.video.paused) stop(state);
      });
      on(state.video, 'error', function () { if (active === state && state.video.error) failure(state, state.request, state.video.error); });
    });
    function measure() {
      var gap = parseFloat(getComputedStyle(viewport).columnGap) || 0;
      loopWidth = originals.reduce(function (sum, card) { return sum + card.offsetWidth + gap; }, 0);
    }
    measure(); on(window, 'resize', measure);
    on(viewport, 'pointerdown', function (event) { pointerStart = { x: event.clientX, y: event.clientY }; }, { passive: true });
    on(viewport, 'pointerup', function (event) {
      if (pointerStart && (Math.abs(event.clientX - pointerStart.x) > 10 || Math.abs(event.clientY - pointerStart.y) > 10)) suppressClickUntil = Date.now() + 400;
      pointerStart = null;
    }, { passive: true });
    on(viewport, 'pointercancel', function () { pointerStart = null; }, { passive: true });
    on(viewport, 'pointerenter', function (event) { if (event.pointerType !== 'touch') hover = true; });
    on(viewport, 'pointerleave', function () { hover = false; });
    on(viewport, 'focusin', function () { hover = true; });
    on(viewport, 'focusout', function () { hover = false; });
    on(viewport, 'scroll', function () {
      if (!loop || wrapping || !loopWidth || viewport.scrollLeft < loopWidth) return;
      // Zero is the legitimate beginning, not a reason to jump to the clones.
      wrapping = true;
      var old = viewport.style.scrollBehavior;
      viewport.style.scrollBehavior = 'auto';
      viewport.scrollLeft -= loopWidth;
      viewport.style.scrollBehavior = old;
      requestAnimationFrame(function () { wrapping = false; });
    }, { passive: true });
    function autoVisible() {
      frame = null;
      if (destroyed || !sectionVisible || active || autoAttempted || interacted || reduced || saveData || root.dataset.autoplayFirst !== 'true') return;
      var best = states.reduce(function (result, state) { return state.video && state.ratio > (result ? result.ratio : 0) ? state : result; }, null);
      if (best && best.ratio >= 0.35) { autoAttempted = true; play(best, true, false); }
    }
    function scheduleAuto() { if (frame === null) frame = requestAnimationFrame(autoVisible); }
    function step() {
      if (!sectionVisible || document.hidden || hover || interacted || active) return;
      var gap = parseFloat(getComputedStyle(viewport).columnGap) || 0;
      var next = viewport.scrollLeft + originals[0].offsetWidth + gap;
      var max = viewport.scrollWidth - viewport.clientWidth;
      if (max > 2) viewport.scrollTo({ left: loop ? next : next >= max - 2 ? 0 : next, behavior: 'smooth' });
    }
    function rotation(visible) {
      if (!visible) { clearInterval(timer); timer = null; return; }
      if (!timer && root.dataset.autoplay === 'true' && !reduced && originals.length > 1) timer = setInterval(step, parseInt(root.dataset.interval, 10) || 4000);
    }
    if ('IntersectionObserver' in window) {
      var cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var state = states.find(function (item) { return item.card === entry.target; });
          if (!state) return;
          state.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          if (active === state && state.ratio < 0.05) stop(state);
        });
        scheduleAuto();
      }, { threshold: [0, 0.05, 0.35, 0.65, 1] });
      states.forEach(function (state) { cardObserver.observe(state.card); });
      observers.push(cardObserver);
      var sectionObserver = new IntersectionObserver(function (entries) {
        sectionVisible = entries[0].isIntersecting;
        if (!sectionVisible && active) stop(active);
        rotation(sectionVisible); scheduleAuto();
      }, { threshold: 0 });
      sectionObserver.observe(root); observers.push(sectionObserver);
    }
    on(document, 'visibilitychange', function () { if (document.hidden && active) stop(active); });
    this.destroy = function () {
      destroyed = true;
      states.forEach(function (state) { if (state.video) stop(state); });
      clearInterval(timer); if (frame !== null) cancelAnimationFrame(frame);
      observers.forEach(function (observer) { observer.disconnect(); });
      listeners.forEach(function (remove) { remove(); });
      viewport.querySelectorAll('[data-lma-vt-clone]').forEach(function (clone) { clone.remove(); });
      delete root._lvnVideoTestimonials;
    };
  }
  function rootsWithin(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-lma-vt]'));
    if (scope.matches && scope.matches('[data-lma-vt]')) roots.unshift(scope);
    return roots;
  }
  function init(scope) {
    rootsWithin(scope).forEach(function (root) {
      if (!root._lvnVideoTestimonials && root.querySelector('[data-lma-vt-viewport]')) root._lvnVideoTestimonials = new Controller(root);
    });
  }
  window.LuveonVideoTestimonials = { init: init };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target).forEach(function (root) {
      if (root._lvnVideoTestimonials && root._lvnVideoTestimonials.destroy) root._lvnVideoTestimonials.destroy();
    });
  });
  init(document);
})();
